import { initReactI18next } from 'react-i18next';

import { ELanguagesValue } from '@svitlofour/types';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    supportedLngs: [
      ELanguagesValue.EN,
      ELanguagesValue.UK,
      ELanguagesValue.HR,
      ELanguagesValue.DE,
    ],
    fallbackLng: ELanguagesValue.EN,
    detection: {
      order: [
        'cookie',
        'navigator',
        'localStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;
